export default "__VITE_ASSET__DDu0Kbn4__"